import MonthRange from './MonthRange.vue'

export default MonthRange
